import { DEFAULT_LANGUAGE, SUPPORTED_LANGUAGES, type SupportedLanguage } from '@/locales'

/**
 * Maps a campaign's stored language (BCP-47-ish, e.g. 'en-GB' or a bare 'de') to
 * the nearest language we actually ship. Falls back to the default when there is
 * no reasonable match, so an exotic campaign language never leaves the page blank.
 */
export function resolveBookingLanguage(campaignLanguage: string | null | undefined): SupportedLanguage {
	if (!campaignLanguage) {
		return DEFAULT_LANGUAGE
	}

	const exactMatch = SUPPORTED_LANGUAGES.find((language) => language === campaignLanguage)
	if (exactMatch) {
		return exactMatch
	}

	const primarySubtag = campaignLanguage.split('-')[0].toLowerCase()
	const primaryMatch = SUPPORTED_LANGUAGES.find(
		(language) => language.split('-')[0].toLowerCase() === primarySubtag,
	)

	return primaryMatch ?? DEFAULT_LANGUAGE
}
